import { FC, PropsWithChildren, DetailedHTMLProps, ButtonHTMLAttributes, MouseEventHandler, MouseEvent } from 'react';
import classNames from 'classnames';
import styles from './index.less';


export interface ButtonProps extends Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'type'> {
  type?: 'default' | 'primary' | 'link' | 'text';
  size?: 'middle' | 'small' | 'large';
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const defaultClickHandler = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
  event.stopPropagation();
  event.preventDefault();
}

const Button: FC<PropsWithChildren<ButtonProps>> = ({
  type = 'default',
  size = 'middle',
  disabled,
  children,
  className,
  onClick,
  ...rest
}) =>
  <button
    className={classNames(
      styles.button,
      styles[type],
      styles[size],
      {
        [styles.disabled]: disabled,
        [className]: className
      }
    )}
    onClick={disabled ? defaultClickHandler : onClick}
    {...rest}
  >
    {children}
  </button>

export default Button;
